'use strict';
import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {DisclosureModalComponent} from '../disclosure-modal/disclosure-modal';
import {AutoDestroy, SessionStorageService} from '@ox/utils';
import {Plans} from '@ox/typings';
import {ShopDataService} from '@webu/data';
import {MyPlansActions, TrackingService, selectMyCurrentPlans} from '@ox/data';
import {isEqual} from 'lodash';
import {Router} from '@angular/router';
import {Subject, take, takeUntil} from 'rxjs';
import {Store} from '@ngrx/store';
@Component({
  selector: 'webu-payment-footer',
  templateUrl: './payment-footer.component.html'
})
export class PaymentFooterComponent implements OnInit {
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  @Input() planName: string;
  @Input() planDisclosure: string;
  @Input() buttonName: string;
  @Input() priceDisclosure?: string;
  @Input() price?: string;
  @Input() trackingString?: string;
  @Input() planStatus?: string;
  @Input() continueButtonSubString?: string;
  @Input() footerString?: string;
  @Input() buttonLoading: boolean;
  @Input() isMonthly?: boolean;
  @Input() isData?: boolean;
  @Input() doHideFrequencyText?: boolean;
  @Input() offerIds: string[] = [];
  @Input() planCount: number;
  byoPrice = 0;
  @Input()
  selectedBYO: Plans[];
  @Input()
  residueBYO: Plans[];

  @Output() continueButton: EventEmitter<string> = new EventEmitter();

  language: string;
  bsModalRef?: BsModalRef;
  selectedPlans: string[];
  isyearlyModify: boolean;
  disclosureItems: any[] = [];

  constructor(
    private modalService: BsModalService,
    private sessionStorageService: SessionStorageService,
    public trackingService: TrackingService,
    private router: Router,
    private shopDataService: ShopDataService,
    private store: Store
  ) {}
  ngOnInit(): void {
    // Make sure copy is called before we get the copy for 'price.disclosure.modal'
    this.shopDataService.getCopyData().pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.disclosureItems.push({
        disclosure: this.getCopy('price.disclosure.modal')
      });
    });
    this.isyearlyModify = this.router.url.includes('/myplans/yearly-billing');
    this.store.select(selectMyCurrentPlans)
      .pipe(take(1))
      .subscribe((myCurrentPlans)=> this.selectedPlans = myCurrentPlans??[]);
  }

  isSelectPlan() {
    const residueSelected = this.selectedBYO.map((item) => item.code);
    return (
      (this.selectedPlans.length == 1 &&
        this.selectedPlans[0] === this.planName &&
        this.residueBYO?.length === 0) ||
      (this.residueBYO.length > 0 &&
        this.selectedPlans.length === this.selectedBYO.length &&
        isEqual([...this.selectedPlans].sort(), [...residueSelected].sort()))
    );
  }

  getDollars(): string {
    const price = '' + (this.price ? this.price : this.byoPrice);
    return price?.substring(0, price?.indexOf('.')) ?? '0';
  }

  getCents(): string {
    const price = '' + (this.price ? this.price : this.byoPrice);
    return price?.substring(price?.indexOf('.') + 1) ?? '0';
  }
  openDisclosureModal(): void {
    const disclosureItems: any[] = [];
    if (this.planName) {
      disclosureItems.push({
        disclosure: this.planDisclosure,
        displayName: this.planName
      });
    }
    this.residueBYO.forEach((item) => {
      disclosureItems.push({
        disclosure: item.disclosure,
        displayName: item.displayName
      });
    });

    if (disclosureItems[0].disclosure) {
      this.bsModalRef = this.modalService.show(DisclosureModalComponent, {
        initialState: {
          product: disclosureItems
        }
      });
    }
  }

  openPriceDisclosureModal(): void {
    if (!this.isyearlyModify) {
      this.sessionStorageService.setAsJson('copyData', this.disclosureItems);
    }
    this.bsModalRef = this.modalService.show(DisclosureModalComponent, {
      initialState: {
        product: this.isyearlyModify 
        ? this.sessionStorageService.getFromJson('copyData') 
        : this.disclosureItems
      }
    });
  }

  buttonClick() {
    this.continueButton.emit();
    this.trackingService.fireProp10Tracking(
      'shop:update plan:button:continue', '', '', 'continue', 'continue', true
    );
    this.sessionStorageService.setAsJson('reviewId', this.offerIds);
  }

  getPlanName() {
    let planName = this.planName && this.planCount === 0 ? this.planName : '';
    planName += !this.planName && this.planCount === 1 ? this.selectedBYO[0].displayName : '';

    planName += this.planName && this.planCount > 0
    ? this.planCount + 1 : this.planCount > 1
    ? this.planCount : '';

    planName += (!(!this.planName && this.planCount === 1) && this.planCount > 0) ? ' Plans' : '';

    return planName;
  }

  getCopy(copyKey: string) {
    return this.shopDataService.getGenericCopy(copyKey);
  }

  doShowSelectPlanCopy() {
    // Do not show "select plan" copy if user is checking out with a new plan
    for (const plan of this.selectedBYO) {
      if (plan.price.status !== 'Active') return false;
    }

    return true;
  }

  fireTracking(planName: string) {
    const trackingString = 'shop:update plan:current plan:' + planName + ':link:plan disclosures';
    console.log('tracking string', trackingString);
    this.trackingService.fireProp10Tracking(trackingString, '', '', 'plan disclosures', '', true);
  }
}